// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueCookies from "vue-cookies";
import iView from "iview";
// import iView from 'view-ui-plus'
import "iview/dist/styles/iview.css";
//  import 'view-ui-plus/dist/styles/viewuiplus.css'
import "../static/css/reset.css";
import "../static/iconfont/iconfont.css";
import { Carousel, CarouselItem, Popover, Slider, Loading, Statistic } from "element-ui";
Vue.use(VueCookies);
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.$basePath = "/pc";
Vue.use(Carousel)
  .use(CarouselItem)
  .use(Popover)
  .use(Slider)
  .use(Loading)
  .use(Statistic);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  iView.LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js